import createNavPages from './createNavPages';
import { LOCAL_STORAGE } from '../constants/constants';
import {jwtDecode} from 'jwt-decode';
import { hasAccessLevel, itAccessIds } from '../constants/access-ids';

// Get user access levels
const accessToken = localStorage.getItem(LOCAL_STORAGE.JJ_INTERNAL);
const userGroups = jwtDecode(accessToken).groups;

const accessLevels = {
    itAccess: hasAccessLevel(userGroups, itAccessIds),
    // warehouseAccess: hasAccessLevel(userGroups),
    // pinsAccess: hasAccessLevel(userGroups, pinsAccessIds),
    pickingAccess: false
};

// Create navPages based on access levels
const navPages = createNavPages(accessLevels);

const menuItems = {
    items: [ navPages ]
    //[dashboard, pages, utilities, other]
};

export default menuItems;